export const useOringScrollToTop = () => {
  const scrollToTop = (behavior: 'auto' | 'smooth' = 'auto') => {
    if (process.client) {
      requestAnimationFrame(() => {
        window.scrollTo({top: 0, left: 0, behavior})
      })
    }
  }

  return {scrollToTop}
}
